import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 300px;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
`;

const UserPrivateMoneyNotAllowed = () => (
  <Wrapper>選択されたマネーはこの機能を使用できません。他のマネーを選択してください。</Wrapper>
);

export default UserPrivateMoneyNotAllowed;
